module.exports = __webpack_public_path__ + "static/media/4ODA14.198851a6.jpg";